"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsModelYandex = void 0;
var tslib_1 = require("tslib");
var social_1 = require("@dp-instant/social");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var PaymentsModelYandex = (function (_super) {
    tslib_1.__extends(PaymentsModelYandex, _super);
    function PaymentsModelYandex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._supported = false;
        return _this;
    }
    PaymentsModelYandex.prototype.init = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._yasdk = config === null || config === void 0 ? void 0 : config.yasdk;
                        this._config = config;
                        this.__initPendingPromise || (this.__initPendingPromise = (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!(this._yasdk && !this._paymentsSDK)) return [3, 4];
                                        _a = this;
                                        return [4, this._yasdk.getPayments({ signed: true })];
                                    case 1:
                                        _a._paymentsSDK = _c.sent();
                                        this._supported = true;
                                        if (!this._supported) return [3, 3];
                                        return [4, this.updatePurchasesAndCatalog()];
                                    case 2:
                                        _c.sent();
                                        _c.label = 3;
                                    case 3: return [3, 6];
                                    case 4:
                                        if (!(!this._catalog || (this._catalog.length === 0 && this._paymentsSDK))) return [3, 6];
                                        _b = this;
                                        return [4, this.fetchCatalog()];
                                    case 5:
                                        _b._catalog = _c.sent();
                                        _c.label = 6;
                                    case 6: return [2];
                                }
                            });
                        }); })());
                        results = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.__initPendingPromise];
                    case 2:
                        results = _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        utils_1.log.warn("failed to initialize payments", e_1);
                        return [3, 4];
                    case 4:
                        delete this.__initPendingPromise;
                        return [2, results];
                }
            });
        });
    };
    PaymentsModelYandex.prototype.updatePurchasesAndCatalog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, catalog, purchases;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, Promise.all([
                            this.fetchCatalog(),
                            this.fetchPurchases()
                        ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), catalog = _a[0], purchases = _a[1];
                        this._catalog = catalog;
                        this._purchases = purchases;
                        return [2];
                }
            });
        });
    };
    PaymentsModelYandex.prototype.fetchCatalog = function () {
        return this._paymentsSDK.getCatalog();
    };
    PaymentsModelYandex.prototype.fetchPurchases = function () {
        return this._paymentsSDK.getPurchases();
    };
    PaymentsModelYandex.prototype.getById = function (id) {
        var _a;
        return (_a = this._catalog) === null || _a === void 0 ? void 0 : _a.filter(function (p) { return p.id == id; })[0];
    };
    PaymentsModelYandex.prototype.getAll = function () {
        return this._catalog || [];
    };
    PaymentsModelYandex.prototype.isPaid = function (id) {
        var _a;
        return !!((_a = this._purchases) === null || _a === void 0 ? void 0 : _a.filter(function (p) { return p.productID == id; })[0]);
    };
    PaymentsModelYandex.prototype.consume = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.trackPurchase("consume_attempt", { token: token });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this._paymentsSDK.consumePurchase(token)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        e_2 = _a.sent();
                        utils_1.log.warn("consumePurchaseAsync", e_2);
                        this.trackPurchase("consume_failed", { error: e_2.code || "unknown", token: token });
                        return [2, false];
                    case 4:
                        this.trackPurchase("consume_success", { token: token });
                        return [4, this.updatePurchasesAndCatalog()];
                    case 5:
                        _a.sent();
                        return [2, true];
                }
            });
        });
    };
    PaymentsModelYandex.prototype.buy = function (id, consumable) {
        var _a;
        if (consumable === void 0) { consumable = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product, purchase, consumed;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        product = this.getById(id);
                        if (!product) {
                            throw new Error("Product with ".concat(id, " not found"));
                        }
                        purchase = (_a = this._purchases) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.productID == id; });
                        if (!!purchase) return [3, 2];
                        return [4, this.performPurchase(product)];
                    case 1:
                        purchase = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!purchase) return [3, 6];
                        if (!consumable) return [3, 4];
                        return [4, this.consume(purchase.purchaseToken)];
                    case 3:
                        consumed = _b.sent();
                        if (consumed) {
                            this.trackEcommerce("purchase", this.trackingPayloadFromProduct(product));
                        }
                        return [2, consumed];
                    case 4:
                        this.trackEcommerce("purchase", this.trackingPayloadFromProduct(product));
                        return [4, this.updatePurchasesAndCatalog()];
                    case 5:
                        _b.sent();
                        return [2, true];
                    case 6: return [2, false];
                }
            });
        });
    };
    PaymentsModelYandex.prototype.performPurchase = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var item_id, purchase, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item_id = product.id;
                        this.trackPurchase("attempt", { item_id: item_id });
                        this.trackEcommerce("begin_checkout", this.trackingPayloadFromProduct(product));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this._paymentsSDK.purchase({ id: item_id })];
                    case 2:
                        purchase = _a.sent();
                        return [3, 4];
                    case 3:
                        e_3 = _a.sent();
                        utils_1.log.error(e_3);
                        switch (e_3.code) {
                            case "USER_INPUT":
                                this.trackPurchase("cancelled", { item_id: item_id });
                                break;
                            default:
                                this.trackPurchase("failed", { error: e_3.code || "unknown", item_id: item_id });
                                return [2];
                        }
                        return [3, 4];
                    case 4:
                        this.trackPurchase("made", { item_id: item_id });
                        return [2, purchase];
                }
            });
        });
    };
    PaymentsModelYandex.prototype.purchase = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.buy(id, false)];
            });
        });
    };
    PaymentsModelYandex.prototype.trackingPayloadFromProduct = function (product) {
        return {
            item_id: product.id,
            item_name: product.title,
            currency: product.priceCurrencyCode,
            value: parseInt(product.priceValue, 10)
        };
    };
    PaymentsModelYandex.prototype.validate = function (purchaseMade) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status;
            return tslib_1.__generator(this, function (_a) {
                status = true;
                return [2, status];
            });
        });
    };
    Object.defineProperty(PaymentsModelYandex.prototype, "purchases", {
        get: function () {
            return this._purchases;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsModelYandex.prototype, "supported", {
        get: function () {
            return this._supported;
        },
        enumerable: false,
        configurable: true
    });
    PaymentsModelYandex = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], PaymentsModelYandex);
    return PaymentsModelYandex;
}(social_1.PaymentsModelBase));
exports.PaymentsModelYandex = PaymentsModelYandex;
//# sourceMappingURL=PaymentsModelYandex.js.map